import View from 'ln/view/View';
import Node from 'ln/node/Node';
/*import VideoPlayer from '../VideoPlayer';*/

class FullscreenButton extends View{

    private resetVolume:number;

    constructor( public target:Node ){
        super();

        this.defaultTemplate = 'lv.video-fullscreen';

    }

    public init(){
        this.node.click.add( this.requestFullscreen, this );
    }

    private requestFullscreen(){
        this.target.native.requestFullscreen();
    }

}

export default FullscreenButton;